export const isArrayLike = x => x && typeof x.length === 'number' && typeof x !== 'function';